import React from 'react';

interface TopStatusItemProps {
  icon: React.ReactNode;
  value: string;
  iconColor: string;
  className?: string;
}

const TopStatusItem: React.FC<TopStatusItemProps> = ({
  icon,
  value,
  iconColor,
  className
}) => {
  return (
    <div 
      className={`w-32 h-7  border-white/80 border-solid border  relative inline-flex items-center gap-2 px-4 py-2 rounded-full shadow-lg backdrop-blur-sm transition-all duration-300 cursor-pointer hover:-translate-y-0.5 hover:shadow-xl md:gap-2 md:px-4 md:py-2 sm:gap-1.5 sm:px-3 sm:py-1.5 text-[#25396E] bg-gradient-to-r from-[#fff]/30 to-[#fff] ${className}`}
    >
      <div 
        className="w-8 h-8  absolute top-1/2 left-0 transform  -translate-y-1/2 flex items-center justify-center text-base md:text-base sm:text-sm w-300 h-300 rounded-full  bg-[#fff]"
        style={{ color: iconColor }}
      >
        {icon}
      </div>
      <span className="w-full text-sm font-semibold text-black whitespace-nowrap md:text-sm sm:text-xs text-right">
        {value}
      </span>
    </div>
  );
};



export default TopStatusItem;